export const digitsOnly = function(input) {
  input = input === 0 ? input : input || '';
  const numberPattern = /\d+/g;
  const matches = input.toString().match(numberPattern);

  if (!matches) {
    return '';
  }

  return matches.join('');
};
